var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"show"},[_c('PageTop',{attrs:{"addShow":false,"sloganShow":true}},[_c('div',{staticClass:"adTitle",attrs:{"slot":"adTitle"},slot:"adTitle"},[_vm._v("农场秀")])]),_c('router-view'),_c('MyNav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }